import { Grid } from "@mui/material";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import EvidenceViewer from "../../components/enterprise/EvidenceViewer";
import { incidentTabs } from "../navigation";
import { platformMockService } from "../../services/mock/platformMockService";
import { useTranslation } from "react-i18next";
import EmptyState from "../../components/dashboard/EmptyState";
import { usePlatform } from "../../context/PlatformContext";

const EvidencePage = () => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  return (
    <ModuleLayout title={t("platform.pages.evidence.title")} subtitle={t("platform.pages.evidence.subtitle")} breadcrumbs={[t("platform.nav.incidents"), t("platform.tabs.evidence")]} tabs={incidentTabs} dataMode={{ mode: showMockData ? "mock" : "real" }}>
      {showMockData ? (
        <Grid container spacing={2.5}>
          {platformMockService.getEvidence().map((item) => (
            <Grid item xs={12} md={6} key={item.id}>
              <EvidenceViewer item={item} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <EmptyState title={t("platform.mock.disabledTitle")} description={t("platform.mock.disabledIncidentsDescription")} />
      )}
    </ModuleLayout>
  );
};

export default EvidencePage;
